import React from "react";

import GewerbeContactForm from "../../GewerbeContactForm";

const Gewerbestrom = ({ name = "com-ele" }) => (
    <GewerbeContactForm type={name} endpoint="commercialElectricity" />
);
export default Gewerbestrom;
